// Local translations
export const T = {
  en_GB: {
    duplicateTemplate: "Duplicate PDF Template",
    cloneDescription:
      "Copy this template with all its sections, pages, components and attachments onto another flow. The copy starts inactive.",
    name: "Name",
    description: "Description",
    targetFlow: "Flow",
    selectFlow: "Select a flow",
    targetFlowHint:
      "Only flows without a PDF template are listed. Fields, quizzes and pages are matched to the chosen flow by name, or by position when it is a copy of the original flow.",
    noFreeFlows: "Every flow already has a PDF template. Create a flow or duplicate one first.",
    pleaseSelectFlow: "Please select a flow",
    translateFromTo: (from: string, to: string) => `Translate texts from ${from} to ${to} with AI`,
    translateHint:
      "All texts are translated together, so terms stay consistent. Placeholders are kept. The translation runs in the background, and the list shows its progress.",
    noTranslateHint: "The copy uses the flow's language, but its texts stay as they are.",
    cancel: "Cancel",
    duplicate: "Duplicate",
    failedToClone: "Failed to duplicate PDF template",
    copyQueued: "Translating the copy. It shows up in the list when it is ready.",
  },
  nb_NO: {
    duplicateTemplate: "Dupliser PDF-mal",
    cloneDescription:
      "Kopier denne malen med alle seksjoner, sider, komponenter og vedlegg til en annen flyt. Kopien starter som inaktiv.",
    name: "Navn",
    description: "Beskrivelse",
    targetFlow: "Flyt",
    selectFlow: "Velg en flyt",
    targetFlowHint:
      "Bare flyter uten PDF-mal vises. Felt, quizer og sider kobles til den valgte flyten etter navn, eller etter plassering når den er en kopi av den opprinnelige flyten.",
    noFreeFlows: "Alle flyter har allerede en PDF-mal. Opprett eller dupliser en flyt først.",
    pleaseSelectFlow: "Velg en flyt",
    translateFromTo: (from: string, to: string) => `Oversett tekstene fra ${from} til ${to} med AI`,
    translateHint:
      "Alle tekstene oversettes samlet, så begrepene blir like. Plassholdere beholdes. Oversettelsen kjører i bakgrunnen, og listen viser fremdriften.",
    noTranslateHint: "Kopien bruker flytens språk, men tekstene beholdes som de er.",
    cancel: "Avbryt",
    duplicate: "Dupliser",
    failedToClone: "Kunne ikke duplisere PDF-mal",
    copyQueued: "Kopien oversettes. Den dukker opp i listen når den er klar.",
  },
} as const;
